export const ROUTER_ANIMATION_TYPE = {
  routerAnimationFadeIn: 'router-animation-fade-in',
  routerAnimationFadeOut: 'router-animation-fade-out',
  routerAnimationInterestIn: 'router-animation-interest-in',
  routerAnimationFullScreen: 'route-animation-full-screen',
};

export const HOMEPAGE_ROUTE_PATH = '/';
export const LOOKBOOK_ROUTE_PATH = '/lookbook/:lookbookId/:title?';
export const CATEGORY_ROUTE_PATH = '/interests/:interestTitle';
export const INTEREST_ROUTE_PATH = '/interests';
export const GAMES_ROUTE_PATH = '/playable';
export const NOT_FOUND_PAGE_ROUTE_PATH = '*';
export const STORIES_ROUTE_PATH = '/stories';
export const DO_NOT_SELL_ROUTE_PATH = '/do-not-sell-my-personal-information';
export const MANAGE_PRIVACY_ROUTE_PATH = '/manage-privacy';
export const ABOUT_US_ROUTE_PATH = '/about-us';
export const CONTACT_US_ROUTE_PATH = '/contact';
export const CONTENT_NOT_AVAILABLE_PATH = '/content-not-available';

export const INTEREST_URL: Record<string, string> = {
  // Production values (existing)
  x6fpXFR: 'adventure',
  '3xfBzCl': 'architecture',
  jxfZUD: 'art-and-design', // Existing: art-and-design, Staging: Art & Design -> art-and-design
  '01f2PHo': 'astrology',
  dofxEcL: 'business',
  '97fvsR': 'cars-and-rides', // Existing: cars-and-rides, Staging: Cars & Rides -> cars-and-rides
  LRfPcJ: 'celebrities',
  '26fgYum': 'celebrity-homes',
  e1frGSP: 'celebrity-style',
  ZofNtA: 'culture',
  oNfDHQ: 'designer-fashion',
  '4xfdS3': 'editorial-photography', // Existing: editorial-photography, Staging: Editorial Photography -> editorial-photography
  '6JfV7FW': 'entertainment',
  Rqfo2tg: 'entertainment-news',
  Rqf2Tg: 'fashion',
  q6fqjSw: 'food-and-drink', // Existing: food-and-drink, Staging: Food & Drink -> food-and-drink
  v4fYViL: 'gear-and-gadgets', // Existing: gear-and-gadgets, Staging: Gear & Gadgets -> gear-and-gadgets
  LRfbPUJ: 'general-news',
  ZofgNIA: 'health',
  v4fVCL: 'home', // Existing: home, Staging: Home & Garden -> home-and-garden
  '1Df64CD': 'influencers',
  // jxfZUD: 'international-news', // UID Conflict with 'art-and-design'. Staging 'International News' UID is jxfZUD.
  g6fYliB: 'lifestyle',
  e1fGFP: 'mens-style', // Existing: mens-style, Staging: Men's Style -> mens-style
  lAfyfy: 'music',
  '4xf2df3': 'news',
  // '3xfzul': 'noteworthy', // UID Conflict with 'architecture'. Staging 'Noteworthy' UID is 3xfBzCl.
  // dofEhL: 'outdoor-photography', // UID Conflict with 'business'. Staging 'Outdoor Photography' UID is x6fpXFR.
  '7mfnQIy': 'personal-finance',
  '01fPho': 'photography', // Existing: photography, Staging: Photography -> photography
  lAfvyuy: 'politics',
  '97fvvHR': 'science', // Existing: science, Staging: Science News -> science-news
  aYfZ9HP: 'science-news', // Existing: science-news, Staging: Science -> science
  ANfkmhe: 'shopping',
  OnfyOho: 'sneakers',
  '01f7Pco': 'sports', // Existing: sports, Staging: Sports News -> sports-news
  '26fbYCm': 'sports-news', // Existing: sports-news, Staging: Sports -> sports
  '97fEvFR': 'strange-news',
  WJfPRCJ: 'technology',
  '3xfzzil': 'technology-news',
  x6fBXcR: 'top-news',
  NZf7cr: 'travel',
  w6fnIL: 'tv-and-film', // Existing: tv-and-film, Staging: TV & Film -> tv-and-film
  v4fBVtL: 'us-news',
  BBfmJtJ: 'wellness',
  VPf7tE: 'womens-style', // Existing: womens-style, Staging: Women's Style -> womens-style

  // Staging values (new or conflicting)
  XofkCl: 'staging-adventure', // New UID for Staging Adventure
  PYfgFZ: 'staging-architecture', // New UID for Staging Architecture
  Gvf4ik: 'staging-art-and-design', // New UID for Staging Art & Design
  EvfvSa: 'staging-astrology', // New UID for Staging Astrology
  kvfkhm: 'staging-business', // New UID for Staging Business
  yBfATv: 'staging-cars-and-rides', // New UID for Staging Cars & Rides
  ngfDcv: 'staging-celebrities', // New UID for Staging Celebrities
  YofPt2: 'staging-celebrity-homes', // New UID for Staging Celebrity Homes
  J1frUR: 'staging-celebrity-style', // New UID for Staging Celebrity Style
  m7fwIp: 'staging-culture', // New UID for Staging Culture
  Dkfqf4: 'staging-designer-fashion', // New UID for Staging Designer Fashion
  '1Df4sD': 'staging-editorial-photography', // New UID for Staging Editorial Photography
  WJfRuJ: 'staging-entertainment-news', // New UID for Staging Entertainment News
  '6Jf7HW': 'staging-entertainment', // New UID for Staging Entertainment
  g6flCB: 'staging-fashion', // New UID for Staging Fashion
  q6fjFw: 'staging-food-and-drink', // New UID for Staging Food & Drink
  ANfmie: 'games', // Staging 'Games' - new category
  // '4xfdS3': 'staging-gear-and-gadgets', // UID Conflict with existing 'editorial-photography'. Staging 'Gear & Gadgets' UID is 4xfdS3.
  // dofEhL: 'staging-general-news', // UID Conflict with existing 'business' & staging 'outdoor-photography'. Staging 'General News' UID is dofEhL.
  // Rqf2Tg: 'staging-health', // UID Conflict with existing 'fashion'. Staging 'Health' UID is Rqf2Tg.
  // LRfPcJ: 'staging-home-and-garden', // UID Conflict with existing 'celebrities'. Staging 'Home & Garden' UID is LRfPcJ.
  // ZofNtA: 'staging-influencers', // UID Conflict with existing 'culture'. Staging 'Influencers' UID is ZofNtA.
  jxfZUD_staging_intl_news: 'staging-international-news', // UID jxfZUD used by prod 'art-and-design' and staging 'International News'
  // w6fnIL: 'staging-lifestyle', // UID Conflict with existing 'tv-and-film'. Staging 'Lifestyle' UID is w6fnIL.
  // lAfyfy: 'staging-mens-style', // UID Conflict with existing 'music'. Staging 'Men's Style' UID is lAfyfy.
  aYf9sP: 'mobile-apps', // Staging 'Mobile Apps' - new category
  // '26fgYum': 'staging-music', // UID Conflict with existing 'celebrity-homes'. Staging 'Music' UID is 26fgYum.
  // '97fvvHR': 'staging-news', // UID Conflict with existing 'science'. Staging 'News' UID is 97fvvHR.
  '3xfBzCl_staging_noteworthy': 'staging-noteworthy', // UID 3xfBzCl used by prod 'architecture' and staging 'Noteworthy'
  x6fpXFR_staging_outdoor_photo: 'staging-outdoor-photography', // UID x6fpXFR used by prod 'adventure' and staging 'Outdoor Photography'
  // v4fYViL: 'staging-personal-finance', // UID Conflict with existing 'gear-and-gadgets'. Staging 'Personal Finance' UID is v4fYViL.
  // e1frGSP: 'staging-photography', // UID Conflict with existing 'celebrity-style'. Staging 'Photography' UID is e1frGSP.
  // OnfyOho: 'staging-politics', // UID Conflict with existing 'sneakers'. Staging 'Politics' UID is OnfyOho.
  // BBfgJTJ: 'staging-science-news', // UID Conflict with existing 'wellness'. Staging 'Science News' UID is BBfgJTJ.
  // '01f7Pco': 'staging-science', // UID Conflict with existing 'sports'. Staging 'Science' UID is 01f7Pco.
  '7mfbQty': 'staging-shopping', // New UID for Staging Shopping
  NZfe7Ur: 'staging-sneakers', // New UID for Staging Sneakers
  VPfY7IE: 'staging-sports-news', // New UID for Staging Sports News
  bYfxyf1: 'staging-sports', // New UID for Staging Sports
  p6fBdsp: 'staging-strange-news', // New UID for Staging Strange News
  Qaf9Lfn: 'staging-technology-news', // New UID for Staging Technology News
  zpfwRHa: 'staging-technology', // New UID for Staging Technology
  r6fAvCa: 'staging-top-news', // New UID for Staging Top News
  oNf1DtQ: 'staging-travel', // New UID for Staging Travel
  XofZkil: 'staging-tv-and-film', // New UID for Staging TV & Film
  PYfagSZ: 'staging-us-news', // New UID for Staging US News
  GvfQ4hk: 'staging-wellness', // New UID for Staging Wellness
  Evf2vfa: 'staging-womens-style', // New UID for Staging Women's Style
  kvfmkcm: 'women', // Staging 'Women' - new category
};
